import { Injectable } from '@angular/core';

@Injectable()
export class CalendarConfig {
    position: string;
    format: string;
    disableDates: boolean;
    locale: string;

    constructor() {
        this.position = "bottomLeft";
        this.format = "DD/MM/YYYY";
        this.disableDates = true;
        this.locale = "es";
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/core/datepicker/calendar-config.ts